<template>
    <v-dialog
        v-model="isOpenModHeadersDialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
    >
        <v-card>
            <v-card-title class="d-flex">
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    <v-icon left> mdi-pencil </v-icon>
                    Columnas a mostar
                </div>
                <div
                    v-else
                    class="font-weight-light primary--text text-h4 ml-2"
                >
                    <v-icon large left> mdi-pencil </v-icon>
                    Columnas a mostar
                </div>
            </v-card-title>
            <v-divider class="test"></v-divider>
            <v-card-text class="mt-2 pb-0">
                <v-list dense>
                    <v-list-item
                        v-for="(header, index) in headers.filter(
                            ({ text }) => text != ''
                        )"
                        :key="index"
                    >
                        <v-checkbox
                            class="pa-0 ma-0"
                            :label="header.text"
                            v-model="header.show"
                        ></v-checkbox>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions class="mx-2">
                <v-switch
                    :label="valueSwitch ? 'Desactivar' : 'Activar'"
                    v-model="valueSwitch"
                    @click="toggleHeaders()"
                ></v-switch>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="closeDialog"> Cerrar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModHeadersTable',
    data: () => ({
        valueSwitch: true,
    }),
    props: {
        headers: Array,
    },
    methods: {
        toggleHeaders() {
            this.headers.forEach((header) => {
                header.show = this.valueSwitch;
            });
        },
        closeDialog() {
            this.isOpenModHeadersDialog = false;
            // this.$store.commit('gerencia/isOpenModHeadersDialog', false);
        },
    },
    computed: {
        isOpenModHeadersDialog: {
            get() {
                return this.$store.state.gerencia.isOpenModHeadersDialog;
            },
            set(value) {
                this.$store.commit('gerencia/isOpenModHeadersDialog', value);
            },
        },
    },
    watch: {
        isOpenModHeadersDialog(value) {
            if (value) {
                this.dialogModHeaders = true;
            }
        },
    },
};
</script>

<style>
</style>